import { ReactComponent as Icon } from "../images/MonyBadge.svg";

const MonyBadge  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default MonyBadge;
